/**
 * @description This enum represents the different SUA-statuses available for a RegisterControl.
 * @author Timothy Biörck
 */

export enum ExportTypes {
  RK_PDF = 'rkPdf',
  RK_PDF_OLD = 'rkPdfOld',
  REPORT_LIST_PDF = 'reportListPdf',
  RK_XML = 'rkXml',
  REPORT_LIST_XML = 'reportListXml',
  SUA_PDF = 'suaPdf',
  SUA_PDF_OLD = 'suaPdfOld',
  SUA_XML = 'suaXml',
  ATTACHMENT = 'attachment',
  SAPO_EXCEL = 'sapoExcel',
  PDF = 'pdf',
  XLSX = 'xlsx'
}

export namespace ExportTypes {

  /**
   * Returns an array of all values that the different types are set to
   * (i.e SuaStatusType.SENT will return the value 'Skickad').
   * @returns {Array<String>} Array of the type's string value.
   */
  export function getValues(): Array<String> {
    return [ 
      ExportTypes.RK_PDF,
      ExportTypes.RK_PDF_OLD,
      ExportTypes.REPORT_LIST_PDF,
      ExportTypes.RK_XML,
      ExportTypes.REPORT_LIST_XML,
      ExportTypes.SUA_PDF,
      ExportTypes.SUA_PDF_OLD,
      ExportTypes.SUA_XML,
      ExportTypes.ATTACHMENT,
      ExportTypes.SAPO_EXCEL,
      ExportTypes.PDF,
      ExportTypes.XLSX

    ]
  }
}
